/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	inprogress: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& .failedmessage': {
      fontSize: pxToEm(12),
      textAlign: 'center',
      color: '#F03840'
    },
    '& .actions': {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(8),
    },
    '& path': {
      fill: '#000'
    },
    '& .button': {
      '&.name-failed': {
        color: '#F03840 !important',
        background: '#FCD6D8',
        border: '1px solid #F03840',
        '& path': {
          fill: 'none'
        }
      },
      '&.name-contactsupport': {
        color: theme.color.primary.medium.contrast,
        background: theme.color.primary.medium.swatch
      }
    }
  }
}; 